<div class="modal-header">
    <rask-header size="2">{{ arbetsorderNamn }}</rask-header>

    <button type="button" class="btn-close" aria-label="Close" (click)="close()">
    </button>
</div>

<rask-container-block>
    <div class="ps-3">{{ 'TPL_TRANSPORTTILLDELA_VALS_DETAILS' | translate }}</div>
    <ng-container footer>
        <rask-button color="primary" (click)="close()">{{ 'DIALOGS_CLOSE' | translate }}</rask-button>
    </ng-container>
</rask-container-block>
